/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box, Container, Stack, Heading} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * Image with text component
 *
 * @param {object} props
 * @param {string} - props.ITCLink - Image Link.
 * @param {string} - props.ITCText - Text Below Image.
 * @param {image} - props.image - Image.
 * @param {string} - props.heading - Text Overlay.
 * @param {string} - props.alt - The image alt text shown by the component.
 * @returns {React.ReactElement} - CarouselSlider component.
 */
export const CarouselSlider = ({carouselImageD, overlayPosition, subHeadingText, headingText}) => {
    return (
        <Box
            position="relative"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundImage={
                carouselImageD?.src?.mobile ? carouselImageD?.src?.mobile : carouselImageD?.url
            }
        >
            {/* This is the block you need to change, to customize the caption */}
            <Container size="container.lg" height="600px" position={overlayPosition}>
                <Stack
                    position="absolute"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    gap="0"
                >
                    <Heading fontWeight="bolder" fontSize="32" color="white" textAlign="left">
                        {headingText}
                    </Heading>
                    <Box
                        fontWeight="400"
                        fontSize="xl"
                        color="white"
                        textAlign="center"
                        py="1.5rem"
                    >
                        {subHeadingText}
                    </Box>
                </Stack>
            </Container>
        </Box>
    )
}

CarouselSlider.propTypes = {
    overlayPosition: PropTypes.string,
    subHeadingText: PropTypes.string,
    headingText: PropTypes.string,
    carouselImageD: PropTypes.shape({
        _type: PropTypes.string,
        focalPoint: PropTypes.shape({
            _type: PropTypes.string,
            x: PropTypes.number,
            y: PropTypes.number
        }),
        metaData: PropTypes.shape({
            _type: PropTypes.string,
            height: PropTypes.number,
            width: PropTypes.number
        }),
        url: PropTypes.string,
        src: PropTypes.string || PropTypes.object
    }).isRequired
}

export default CarouselSlider
